module.exports = __webpack_public_path__ + "img/storm_check.3c3a5b9d.svg";